import { createDecorator } from '../../instantiation/common/instantiation.js';
const ITunnelService = ( createDecorator('tunnelService'));
export { ITunnelService };
